// extracted by mini-css-extract-plugin
export default {"tabList":"tabList-xtB1h","tab":"tab-h7QId","tabPanel":"tabPanel-K3lKE","tabsSkeleton":"tabsSkeleton-eeHPz"};